import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import Location from '~/containers/location/location';

export class LocationPage extends Component {
  state = {
    location: null
  };

  onReceiveLocation = ({ location }) => {
    this.setState({
      location
    });
  };

  render() {
    const locationId = this.props.match.params.locationId;
    const { location } = this.state;

    const editButton = (
      <Link to={`/settings/locations/${locationId}/edit`}>
        <Button color="primary">Edit</Button>
      </Link>
    );

    return (
      <Page>
        <TitleBar
          back="/settings/locations"
          backText="Locations"
          title={location ? location.name : '...'}
          button={editButton}
        />
        <Location onCompleted={this.onReceiveLocation} id={locationId} />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(LocationPage));



// WEBPACK FOOTER //
// ./src/pages/location/location.jsx